import React, { useState } from 'react'
import {
  View,
  ScrollView,
  TouchableOpacity,
  ImageBackground,
  Platform,
  Text as RnText,
  TouchableWithoutFeedback,
  Dimensions,
  StatusBar,
  Pressable
} from 'react-native'
import PropTypes from 'prop-types'
import LinearGradient from 'react-native-linear-gradient'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'
// eslint-disable-next-line import/no-named-as-default
import WebView from 'react-native-webview'

import MigrationLottie from '../../Components/MigrationLottie'

import VfText from '../../Components/VfText'
import Modal from '../../Components/Modal'
import VFButton from '../../Components/VFButton'

import images from '../../Themes/Images'
import { winter, summer } from '../../Themes/Themes'

import styles, { modalStyles } from './Quiz.Styles'

import _Modal from 'react-native-modal'


const Themes = { winter, summer }

function LevelSelection({
  navigateToQuizGame,
  theme,
  quizLevels = [],
  startQuizLevel,
  loading,
  setLoading,
  setIsLevelSelect
}) {

  const {
    firstLevel,
    secondLevel,
    thirdLevel,
  } = Themes[theme]

  const icons = [firstLevel, secondLevel, thirdLevel]
  const [iconLoading, setIconLoading] = useState([false, false, false])
  const pressQuizLevel = async (id, levelNumber, optionsNr, index) => {

    try {
      await startQuizLevel(
        id,
        {
          onStart: () => {
            const iconsLoadingCopy = iconLoading.slice()
            iconsLoadingCopy[index] = true
            setIconLoading(iconsLoadingCopy)
            setLoading(true)
          },
          responseMapper: () => { },
          onError: (e) => setLoading(false),
          onSuccess: (res) => {
            setIconLoading([false, false, false])
            setLoading(false)
            navigateToQuizGame(levelNumber, res, optionsNr)
            setIsLevelSelect(false)
          },
        })

    } catch (e) {
      console.log(e, 'errori')
    }

  }

  return (
    <ScrollView >
      <VfText
        size="h1"
        weight="bold"
        align="left"
        style={styles.levelSelectorHeader}
        // isLoading={isContentLoading}
        i18nKey="quiz_level_selection_title"
      />
      <VfText
        size="h2"
        weight="bold"
        align="left"
        style={styles.levelSelectorSubHeader}
        // isLoading={isContentLoading}
        i18nKey="quiz_level_selection_subtitle"
      />
      <View style={styles.cardsWrapper}>
        {quizLevels?.map((item, index) => (
          <GameLevelCard
            {...item}
            icon={icons[index]}
            iconLoading={iconLoading[index]}
            onPress={() => !loading && pressQuizLevel(item?.id, item?.level, item?.optionsNr, index)}
          />))
        }

      </View>

    </ScrollView>
  )
}

LevelSelection.propTypes = {
  navigateToQuizGame: PropTypes.func,
  theme: PropTypes.string,
  quizLevels: PropTypes.array,
  startQuizLevel: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
}

const GameInfo = ({ setIsLevelSelect, theme, getQuizLevels, loading, setLoading, openMoreInfo }) => {

  const {
    quizLetters,
  } = Themes[theme]


  const getLevels = async () => {
    try {
      const res = await getQuizLevels({
        onStart: () => { setLoading(true) },
        onError: (e) => { setLoading(false); console.log(e, 'eeeeasde') },
        onSuccess: (_res) => { setLoading(false); setIsLevelSelect(true); console.log(_res) },
      })

    } catch (e) {
      console.log(e, 'errori')
    }

  }

  return (
    <View style={{ flex: 1 }}>
      <VfText
        size="h1"
        weight="bold"
        align="center"
        style={styles.levelSelectorHeader}
        // isLoading={isContentLoading}
        i18nKey="quiz_title"
      />
      <VfText
        size="h5"
        // weight="bold"
        align="center"
        style={styles.levelSelectorSubHeader}
        // isLoading={isContentLoading}
        i18nKey="quiz_level_selection_subtitle"
      />
      <Icon
        name={quizLetters}
        type="image"
        style={styles.quizLetters}
        resizeMode="contain"
        size={350}
      />
      <View style={{ flex: 1, justifyContent: 'flex-end', paddingBottom: 20 }}>
        <VFButton
          type="primary"
          title={'quiz_main_button'}
          onPress={getLevels}
          style={styles.quizInfoButton}
          isLoading={loading}
          loadingTitle={'promo_processing_button'}
        />
        <VfText
          size="h5"
          onPress={() => openMoreInfo(ContentManager.translate('un_game_sdg_info_link'), 'quiz_sdg_info_label')}
          style={styles.underline}
          align="center"
          i18nKey="quiz_sdg_info_label"
        />
      </View>
    </View>
  )
}
GameInfo.propTypes = {
  setIsLevelSelect: PropTypes.func,
  theme: PropTypes.string,
  getQuizLevels: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  displayDetails: PropTypes.func,
}

function GameLevelCard({ icon, description, info, onPress, iconLoading }) {
  const [theme] = useState('summer')

  const {
    starlesssIcon,
  } = Themes[theme]

  return (
    <Pressable
      onPress={onPress}>
      <View style={styles.cardWrapper}>
        {iconLoading ? <ImageBackground source={starlesssIcon} resizeMode="contain" style={{ height: 80 }} >
          <View style={modalStyles.lottieWrapper}>
            <MigrationLottie
              source={require('./loaderE60000.json')}
              style={modalStyles.lottie}
            />
          </View>
        </ImageBackground> : <Icon
          name={icon}
          type="image"
          resizeMode="contain"
          size={80}
        />}
        <View style={[styles.cardTextWrapper, { padding: 20 }]}>
          <RnText style={styles.cardText}>
            <RnText>{description}</RnText>
          </RnText>
          <RnText style={styles.infoText}>
            <RnText>{info}</RnText>
          </RnText>
        </View>

      </View>
    </Pressable>
  )
}
GameLevelCard.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  boldText: PropTypes.string,
  onPress: PropTypes.func,
  description: PropTypes.string,
  info: PropTypes.string,
  iconLoading: PropTypes.bool,
}

function Quiz({
  onClose,
  navigateToQuizGame,
  openQuizGame,
  getQuizLevels,
  startQuizLevel,
  quizLevels,
  openMoreInfo
}) {
  const [theme] = useState('summer')
  const insets = useSafeAreaInsets()
  const { height } = Dimensions.get('screen')

  const {
    gradient,
    primary,
    quizInfo,
    background1,
    background2,
  } = Themes[theme]

  const [isLevelSelect, setIsLevelSelect] = useState(false)
  const [loading, setLoading] = useState(false)
  // const [quizLevels, setQuizLevels] = useState([])

  const [details, setDetails] = useState({
    isVisible: false,
    onHide: null,
    title: '',
    url: '',
  })


  function dismissDetails(onHide = () => { }) {
    setDetails({
      isVisible: false,
      onHide: null,
      title: '',
      url: '',
    })
  }
  function displayDetails(title, url) {
    setDetails({ isVisible: true, title, url })
  }

  const closeScreen = () => {
    if (isLevelSelect) {
      setIsLevelSelect(false)
    } else {
      onClose()
    }
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <LinearGradient
        colors={gradient}
        useAngle={true}
        angleCenter={{ x: 0.5, y: 0.5 }}
        angle={30}
        style={styles.background}
      >
        <ImageBackground source={isLevelSelect ? background2 : background1} style={styles.background} resizeMode="cover" >
          <StatusBar
            barStyle="light-content"
            translucent
            backgroundColor={'transparent'}
            animated
            showHideTransition="fade"
          />
          <ScrollView contentContainerStyle={{ paddingHorizontal: '10%', flex: 1 }}>
            <View style={styles.headerContentWrapper(insets.top)}>
              <TouchableOpacity onPress={() => displayDetails('quiz_info_title', ContentManager.translate('un_game_more_info_link'))} disabled={!onClose}>
                <Icon
                  name={quizInfo}
                  type="image"
                  resizeMode="contain"
                  size={48}
                />
              </TouchableOpacity>
              <TouchableOpacity onPress={closeScreen} disabled={false}>
                <Icon
                  name={images.close}
                  type="image"
                  resizeMode="contain"
                  size={24}
                  style={styles.closeIcon(primary)}
                />
              </TouchableOpacity>
            </View>
            <ScrollView
              nestedScrollEnabled={true}
              contentContainerStyle={styles.scrollContainer(insets.bottom)}
              showsVerticalScrollIndicator={false}
            >
              {isLevelSelect ?
                <LevelSelection
                  navigateToQuizGame={navigateToQuizGame}
                  quizLevels={quizLevels}
                  theme={theme}
                  loading={loading}
                  setLoading={setLoading}
                  startQuizLevel={startQuizLevel}
                  setIsLevelSelect={setIsLevelSelect}
                /> :
                <GameInfo
                  setIsLevelSelect={setIsLevelSelect}
                  theme={theme}
                  getQuizLevels={getQuizLevels}
                  loading={loading}
                  setLoading={setLoading}
                  displayDetails={displayDetails}
                  openMoreInfo={openMoreInfo}
                />}
            </ScrollView>
          </ScrollView>
        </ImageBackground>
        <_Modal
          isVisible={details.isVisible}
          backdropOpacity={0.5}
          onSwipeComplete={dismissDetails}
          onBackdropPress={dismissDetails}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          {/* <View style={modalStyles.detailsContent}> */}
          <View style={{
            height: height * 0.7,
            minWidth: '600px',
            maxWidth: '600px',
            backgroundColor: 'white',
            margin: 'auto',
            padding: '20px',
            borderRadius: "7px",
          }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <VfText
                size="h4"
                weight="bold"
                // isLoading={isContentLoading}
                // i18nKey="quiz_info_title"
                i18nKey={details?.title}
              />
              <TouchableOpacity onPress={() => dismissDetails()}>
                <Icon
                  source={images.close}
                  size={20}
                  type="image"
                  resizeMode="contain"
                  style={{
                    tintColor: Colors.thinDark,
                  }}
                />
              </TouchableOpacity>
            </View>

            <ScrollView contentContainerStyle={[styles.infoScroller, { flex: 1 }]}>
              <View
                style={{ flex: 1 }}
                onStartShouldSetResponder={() => true}>
                <WebView
                  // source={{ uri: 'https://api-web-ci-vfal.vodafone.com/file/2020promo/MoreInfoPromo_AL.html' }}
                  source={{ uri: details?.url }}
                  startInLoadingState={true}
                  renderLoading={() => (
                    <View style={modalStyles.webLottieWrapper}>
                      <MigrationLottie
                        source={require('./loaderE60000.json')}
                        style={modalStyles.webLottie}
                      />
                    </View>
                  )}
                />
              </View>
            </ScrollView>
          </View>
        </_Modal>
      </LinearGradient >
    )
  }


  return (
    <LinearGradient
      colors={gradient}
      useAngle={true}
      angleCenter={{ x: 0.5, y: 0.5 }}
      angle={30}
      style={styles.background}
    >
      <ImageBackground source={isLevelSelect ? background2 : background1} style={styles.background} resizeMode="cover" >
        <SafeAreaView
          style={styles.container()}
          edges={['right', 'left']}>
          <View style={styles.headerContentWrapper(insets.top)}>
            <TouchableOpacity onPress={() => displayDetails('quiz_info_title', ContentManager.translate('un_game_more_info_link'))} disabled={!onClose}>
              <Icon
                name={quizInfo}
                type="image"
                resizeMode="contain"
                size={48}
              />
            </TouchableOpacity>
            <TouchableOpacity onPress={closeScreen} disabled={false}>
              <Icon
                name={images.close}
                type="image"
                resizeMode="contain"
                size={24}
                style={styles.closeIcon(primary)}
              />
            </TouchableOpacity>
          </View>
          <ScrollView
            nestedScrollEnabled={true}
            contentContainerStyle={styles.scrollContainer(insets.bottom)}
            showsVerticalScrollIndicator={false}
          >
            {isLevelSelect ?
              <LevelSelection
                navigateToQuizGame={navigateToQuizGame}
                quizLevels={quizLevels}
                theme={theme}
                loading={loading}
                setLoading={setLoading}
                startQuizLevel={startQuizLevel}
                setIsLevelSelect={setIsLevelSelect}
              /> :
              <GameInfo
                setIsLevelSelect={setIsLevelSelect}
                theme={theme}
                getQuizLevels={getQuizLevels}
                loading={loading}
                setLoading={setLoading}
                displayDetails={displayDetails}
                openMoreInfo={openMoreInfo}
              />}
          </ScrollView>
        </SafeAreaView>
      </ImageBackground>
      <Modal
        visible={details.isVisible}
        close={() => dismissDetails()}
        onModalHide={() => details.onHide?.()}
        style={{ maxHeight: 650 }}
        insets={insets}
      >
        <View style={modalStyles.detailsContent}>

          <VfText
            size="h4"
            weight="bold"
            // isLoading={isContentLoading}
            // i18nKey="quiz_info_title"
            i18nKey={details?.title}
          />
          <TouchableOpacity onPress={() => dismissDetails()}>
            <Icon
              source={images.close}
              size={20}
              type="image"
              resizeMode="contain"
              style={{
                tintColor: Colors.thinDark,
              }}
            />
          </TouchableOpacity>
        </View>
        <ScrollView contentContainerStyle={styles.infoScroller}>
          <View
            style={{ height: height * 7 / 10 }}
            onStartShouldSetResponder={() => true}>
            <WebView
              // source={{ uri: 'https://api-web-ci-vfal.vodafone.com/file/2020promo/MoreInfoPromo_AL.html' }}
              source={{ uri: details?.url }}
              style={modalStyles.webView}
              startInLoadingState={true}
              renderLoading={() => (
                <View style={modalStyles.webLottieWrapper}>
                  <MigrationLottie
                    source={require('./loaderE60000.json')}
                    style={modalStyles.webLottie}
                  />
                </View>
              )}
            />
          </View>

        </ScrollView>
      </Modal>
    </LinearGradient >
  )
}

Quiz.defaultProps = {}

Quiz.propTypes = {
  onClose: PropTypes.func,
  getUserDetails: PropTypes.func,
  navigateToQuizGame: PropTypes.func,
  openQuizGame: PropTypes.func,
  getQuizLevels: PropTypes.func,
  startQuizLevel: PropTypes.func,
}

export default Quiz
